import { render, staticRenderFns } from "./EditorFluxo.vue?vue&type=template&id=934f9396&"
import script from "./EditorFluxo.vue?vue&type=script&lang=js&"
export * from "./EditorFluxo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports